export const galleryData = [
  {
    id: 103,
    src: "/assets/gallery/gallery1.jpeg",
    alt: "Paragliding in Nepal – Pokhara adventure travel, Himalayas view",
  },
  {
    id: 104,
    src: "/assets/gallery/gallery2.jpeg",
    alt: "Paragliding Nepal – Pokhara travel adventure, Amazing Nepal",
  },
  {
    id: 105,
    src: "/assets/gallery/gallery3.jpeg",
    alt: "Nepal paragliding – Pokhara travel experience, Himalayas",
  },
  {
    id: 106,
    src: "/assets/gallery/gallery4.jpeg",
    alt: "Nepal travel adventure – paragliding Pokhara, Amazing Nepal",
  },
  {
    id: 107,
    src: "/assets/gallery/gallery5.jpeg",
    alt: "Paragliding Nepal travel – Pokhara Himalayas, Amazing Nepal",
  },
  {
    id: 108,
    src: "/assets/gallery/gallery6.jpeg",
    alt: "Nepal adventure travel – paragliding Pokhara",
  },
  {
    id: 109,
    src: "/assets/gallery/gallery7.jpeg",
    alt: "Nepal travel – paragliding adventure Pokhara, Himalayas",
  },
  {
    id: 110,
    src: "/assets/gallery/gallery8.jpeg",
    alt: "Paragliding in Nepal – travel and adventure, Amazing Nepal",
  },
  {
    id: 111,
    src: "/assets/gallery/gallery9.jpeg",
    alt: "Nepal travel paragliding – Pokhara adventure, Himalayas",
  },
  {
    id: 2,
    src: "/assets/destination/everest1.jpeg",
    alt: "Mount Everest Nepal trek – Himalayas travel, Everest Base Camp",
  },
  {
    id: 3,
    src: "/assets/destination/everesthelicoptor.jpeg",
    alt: "Everest helicopter tour Nepal – Himalayas travel, Amazing Nepal",
  },
  {
    id: 4,
    src: "/assets/destination/annapurna.jpeg",
    alt: "Annapurna trek Nepal – Himalayas trekking, Amazing Nepal",
  },
  {
    id: 1,
    src: "/assets/destination/bhotekoshi.jpeg",
    alt: "Nepal adventure travel – Bhotekoshi helicopter tour, Himalayas",
  },
  {
    id: 8,
    src: "/assets/destination/mardi.jpeg",
    alt: "Mardi Himal trek Nepal – Himalayas trekking, Amazing Nepal",
  },
  {
    id: 32,
    src: "/assets/recommended/everest.jpeg",
    alt: "Everest helicopter tour Nepal – Himalayas travel, Amazing Nepal",
  },
  {
    id: 41,
    src: "/assets/recommended/annapurna.jpeg",
    alt: "Annapurna region Nepal travel – trekking Himalayas, Amazing Nepal",
  },
  {
    id: 51,
    src: "/assets/recommended/chitwan.jpeg",
    alt: "Chitwan National Park Nepal – wildlife safari travel, Amazing Nepal",
  },
  {
    id: 63,
    src: "/assets/recommended/everest.jpeg",
    alt: "Everest region Nepal trek – Himalayas travel, Amazing Nepal",
  },
  {
    id: 73,
    src: "/assets/recommended/kathmandu.jpeg",
    alt: "Kathmandu Nepal travel – cultural heritage and temples, Amazing Nepal",
  },
  {
    id: 82,
    src: "/assets/recommended/lumbini.jpeg",
    alt: "Lumbini Nepal – Buddha birthplace pilgrimage travel, Amazing Nepal",
  },
  {
    id: 101,
    src: "/assets/nepal/heritage.jpg",
    alt: "Nepal heritage travel – UNESCO cultural site, Amazing Nepal",
  },
];
